import { useEffect } from 'react';
import styles from './PharmacyLocatorPage.module.css';

export function PharmacyLocatorPage() {
  const pharmacyLocatorUrl = 'https://optum.seafoamsearch.com/portal/dol';

  useEffect(() => {
    document.title = 'DOL Pharmacy Locator';
  }, []);

  return (
    <main className={styles.page}>
      <iframe
        className={styles.frame}
        src={pharmacyLocatorUrl}
        title="DOL Pharmacy Locator"
      />
    </main>
  );
}
